(function() {
    'use strict';
    angular.module('wbDashboard').factory('PlanningService', ['$q', '$window', '$uibModal', 'Request', 'User', 'Track', function ($q, $window, $uibModal, Request, User, Track) {
        var plan = {
                user: {}
            },

            planData = {
                'surveysInfo' : null,
                'surveys' : null,
                'surveysCompleted' : null,
                'recommendations' : null,
                'recommendationInfo' : null,
                'previousRecommendations' : null,
                'stageCompletedName' : false,
                'backToPlanning': null,
            },
            promises = {
            };

        plan.riskInfo = {
            surveyId: "248115",
            slug: "survey-248115"
        };
        plan.partnerInfo = {
            haven: {
                surveyId: "164483",
                slug: "protect-your-loved-ones"
            },
            studentRefi: {
                surveyId: "222865",
                slug: "shed-your-loans"
            },
            mortgage: {
                surveyId: "558336",
                slug: "lower-your-mortgage-1"
            },
            mortgageNew: {
                surveyId: "681966",
                slug: "find-a-mortgage"
            }
        };
        plan.partnerListSurveyId = function() {
            var list = [];
            angular.forEach(plan.partnerInfo, function(value) {
                list.push(value.surveyId);
            });
            return list;
        }();

        /**
         * Returns entire planData object
         */
        plan.getPlanData = function() {
            return plan.get();
        };

        /**
         * Get specific planData key
         * @param type
         * @returns {*}
         */
        plan.get = function (type) {
            if (!type) {
                return planData;
            } else {
                return planData[type];
            }
        };
        /**
         * Clear any planData key or entire object
         * @param type
         * @returns {boolean}
         */
        plan.clear = function (type) {
            if (type) {
                if (!(type in planData)) {
                    throw new Error("PlanningService: Invalid type in planData");
                }
                planData[type] = null;
            } else {
                Object.keys(planData).forEach(function(key) {
                    planData[key] = null;
                });
            }
            return true;
        };
        /**
         * Manually update any particular data in any planData key
         * @param type
         * @param data
         */
        plan.manualSet = function(type, data) {
            if (!(type in planData)) {
                throw new Error("PlanningService: Invalid type in planData");
            }
            planData[type] = planData[type] || {};
            planData[type] = angular.extend(planData[type], data);
        };


        /********************************************************
         * SERVER REQUESTS AND DATA RETRIEVAL
         ********************************************************/


        /**
         * Get all recommendation data that's already been retrieved
         * @returns {*}
         */
        plan.getRecommendations = function (slug) {
            var returnR = null;
            var surveys = plan.get('recommendations');
            if (!slug) {
                returnR = surveys;
            } else {
                angular.forEach(surveys, function (r) {
                    if (r.recommendation_slug === slug) {
                        returnR = r;
                    }
                });
            }
            return returnR;
        };
        plan.getRecommendationInfo = function () {
            return plan.get('recommendationInfo');
        };
        /**
         * Request all recommendation data from server
         * @returns Promise
         */
        plan.retrieveRecommendations = function (slug, refresh) {
            if (typeof(slug) === "boolean") {
                refresh = slug;
                slug = null;
            }

            if (plan.getRecommendations(slug) && !refresh) {
                return $q.when(plan.getRecommendations(slug));
            } else {
                if (slug) {
                    return Request.make('user_recommendation_slug', {slug: slug}).then(function (response) {
                        var r = response.data.recommendation;
                        //this push will likely be overwritten by a call to recommendations rather quickly
                        if (planData.recommendations) {
                            planData.recommendations.push(r);
                        }
                        return r;
                    });
                } else {
                    var sample = [ //for adding recommendations to test
                        // {
                        //     recommendation_slug:"123abc",
                        //     stage: "Getting Started",
                        //     recommendation_description: { title: "Testing" },
                        //     action: "none",
                        //     image_token: "plan",
                        //     dismissible: true,
                        //     dismissible_reasons: [
                        //         'Because',
                        //         'I said so',
                        //         'Go away'
                        //     ],
                        //     snoozable: true,
                        //     completable: true,
                        //     landing_description: {
                        //         title: "Testing",
                        //         sub_title: "sub title",
                        //         description: "stuff about the thing",
                        //         button_text: "Done the thing",
                        //         color: "#32bea6",
                        //         info: null
                        //     },
                        // }
                    ];
                    let response = {
                        "data": {
                            "current_stage": "Getting Started",
                            "completed_recommendations": 0,
                            "total_recommendations": 0,
                            "stage_percentage_complete": 0,
                            "previous_stage": "Getting Started",
                            "surveys_completed_percent": 100,
                            "recommendations": []
                        }
                    };

                    //no longer care about retrieving this
                    //also don't want to update all the code to remove it from everywhere, so use mock data

                    //return Request.make('user_recommendations').then(function (response) {
                    return $q.when(response).then(function (response) {
                        planData.previousRecommendations = !!planData.recommendations && !!planData.recommendations.length;

                        planData.recommendationInfo = response.data;
                        if (planData.recommendationInfo.current_stage !== planData.recommendationInfo.previous_stage) {
                            planData.stageCompletedName = planData.recommendationInfo.previous_stage;
                        }

                        var stages = ["Getting Started", "Building Foundation", "Mitigating Risk", "Increasing Efficiency"];
                        planData.recommendationInfo.current_stage_number = stages.indexOf(planData.recommendationInfo.current_stage) + 1;

                        planData.recommendations = response.data.recommendations.concat(sample);

                        //Track.register("stage", planData.recommendationInfo.current_stage);

                        return planData.recommendations;
                    }).catch(function () {
                        planData.recommendations = [];
                        return planData.recommendations;
                    });
                }
            }
        };
        /**
         * @deprecated Don't this this is needed, all uses are commented out.  Rather than remove a recommendation,
         *              the list is just refreshed when something would have been removed or changed.
         * @param slug
         */
        plan.removeRecommendationItem = function(slug) {
            var r = plan.getRecommendations();
            for (var i = r.length-1; i >=0; i--) {
                if (r[i].recommendation_slug === slug) {
                    r.splice(i, 1);
                }
            }
        };
        plan.dismissRecommendation = function(slug, reason) {
            return Request.make('user_recommendation_dismiss', {slug: slug, reason: reason}).then(function (response) {
                Track.send("Recommendation Dismissed", "planning", {recommendation: slug, dismiss: reason});

                return response;
            });
        };
        plan.snoozeRecommendation = function(slug, date, days) {
            return Request.make('user_recommendation_snooze', {slug: slug, snooze_until: date}).then(function (response) {
                Track.send("Recommendation Snoozed", "planning", {recommendation: slug, snooze_length: days});

                return response;
            });
        };
        plan.completeRecommendation = function(slug) {
            return Request.make('user_recommendation_complete', {slug: slug}).then(function (response) {
                Track.send("Recommendation Completed", "planning", {recommendation: slug});

                return response;
            });
        };


        /**
         * Get all survey info data that's already been retrieved
         * @returns {*}
         */
        plan.getSurveysInfo = function (sId) {
            var returnSurvey = null;
            var surveys = plan.get('surveysInfo');
            if (!sId) {
                returnSurvey = surveys;
            } else {
                angular.forEach(surveys, function (s) {
                    if (s.id === sId) {
                        returnSurvey = s;
                    }
                });
            }
            return returnSurvey;
        };
        /**
         * Request all survey info data from server
         * @returns Promise
         */
        plan.retrieveSurveysInfo = function (refresh) {
            if (plan.get('surveysInfo') && !refresh) {
                return $q.when(plan.get('surveysInfo'));
            } else {
                return Request.make('user_surveys_info').then(function (response) {
                    planData.surveysInfo = response.data.surveys;
                    return planData.surveysInfo;
                });
            }
        };

        /**
         * Get all completed surveys data that's already been retrieved
         * @returns {*}
         */
        plan.getSurveysCompleted = function (sId) {
            var returnSurvey = null;
            var surveys = plan.get('surveysCompleted');
            if (!sId) {
                returnSurvey = surveys;
            } else {
                angular.forEach(surveys, function (s) {
                    if (s.id === sId) {
                        returnSurvey = s;
                    }
                });
            }
            return returnSurvey;
        };
        /**
         * Request all completed surveys data from server
         * @returns Promise
         */
        plan.retrieveSurveysCompleted = function (sId, refresh) {
            if (plan.getSurveysCompleted(sId) && !refresh) {
                return $q.when(plan.getSurveysCompleted(sId));
            } else {
                return Request.make('user_surveys_completed').then(function (response) {
                    var surveys = response.data.surveys;
                    var answers;
                    angular.forEach(surveys, function (s) {
                        answers = {};
                        angular.forEach(s.answers, function (a) {
                            var fixedAnswer;
                            if (a.answer === null && a.answer_array.length) {
                                fixedAnswer = {};
                                a.answer_array.forEach(function(value) {
                                    fixedAnswer[value] = true;
                                });
                            } else if ((a.answer && !isNaN(a.answer)) || a.answer === "0" || a.answer === 0) {
                                //numeric, make it so
                                fixedAnswer = a.answer * 1;
                            } else {
                                fixedAnswer = a.answer;
                            }
                            answers[a.question_id] = fixedAnswer;
                        });
                        s.answers = answers;
                        s.completed_at = moment(s.completed_at).toDate();
                    });
                    planData.surveysCompleted = surveys;

                    return plan.getSurveysCompleted(sId);
                });
            }
        };

        /**
         *
         */
        plan.getSurvey = function (sId) {
            var survey = plan.get('surveys');
            if (sId && survey && sId in survey) {
                return survey[sId];
            } else if (sId || !survey) {
                return null;
            } else if (!sId) {
                return survey;
            }
        };
        /**
         * Request detailed survey info from server based on id
         * @returns {*}
         */
        plan.retrieveSurvey = function (sId, refresh) {
            if (plan.getSurvey(sId) && !refresh) {
                return $q.when(plan.getSurvey(sId));
            } else {
                return Request.make('user_survey', {sId: sId}).then(function (response) {
                    /* jshint expr: true */
                    planData.surveys || (planData.surveys = {});
                    /* jshint eqnull: true */
                    planData.surveys[sId] = response.data;

                    angular.forEach(planData.surveys[sId].questions, function(q) {
                        if (q.code === "NumOfChildren") {
                            q.attributes.validation || (q.attributes.validation = {});
                            q.attributes.validation.max = 50;
                        }
                    });

                    return planData.surveys[sId];
                });
            }
        };

        /**
         *
         * @param sId
         * @param answers
         * @returns Promise
         */
        plan.saveSurvey = function(sId, answers) {
            return Request.make('user_surveys_save', {sId: sId, answers: answers}).then(function(response) {
                return response;
            });
        };


        /********************************************************
         * UTILITY
         ********************************************************/

        /**
         * Retrieves a question via question code or id
         * @param questions
         * @param code
         * @returns {*}
         */
        plan.getQuestion = function(questions, code) {
            var returnQ = null;
            angular.forEach(questions, function(q) {
                if (q.code === code || q.id === code) {
                    returnQ = q;
                }
            });
            return returnQ;
        };

        plan.checkRule = function(answer, expected, operator) {
            var valid;
            if (typeof answer === "object") {
                alert('RULE OBJECT');
            } else {
                switch (operator) {
                    case "==":
                        valid = answer == expected;
                        break;
                    case "!=":
                        valid = answer != expected;
                        break;
                }

            }

            return valid;
        };

        plan.recommendationAction = function(recommendation, $state) {
            var milestone;
            var redirected;
            planData.backToPlanning = false;
            return $q.when(1).then(function() {
                switch (recommendation.action) {
                    case 'haven':
                    case 'student_refinance':
                    case 'mortgage_refinance':
                    case 'mortgage_origination':
                    /* falls through */
                    case 'survey':
                        redirected = $state.go('base.planning.survey.question', {sId: recommendation.action_type, recommendationSlug: recommendation.recommendation_slug});
                        break;
                    case 'blog':
                        planData.backToPlanning = true;
                        $window.open(recommendation.action_type, '_blank');
                        break;
                    case 'axos_bank_account':
                        planData.backToPlanning = true;
                        $window.open(recommendation.action_type_axos_url || recommendation.action_type, '_blank');
                        break;
                    case 'new_milestone':
                        redirected = $state.go('base.milestone-mod.create.steps', {msType: recommendation.action_type}, {location: 'replace'});
                        break;
                    case 'auto_deposit':
                        redirected = $state.go('base.funding.auto-deposit');
                        break;
                    case 'new_account':
                        milestone = User.getMilestoneByType('retirement');
                        if (milestone) {
                            redirected = $state.go("base.plans.detail.plan.feature.detail",{pslug:'taxplan', fslug:'taxpreferredaccount'});
                        } else {
                            planData.backToPlanning = true;
                        }
                        break;
                    case 'tax_plan':
                        if (!recommendation.action_type) {
                            redirected = $state.go('base.plans.info', {pslug: 'taxplan'});
                        } else {
                            redirected = $state.go('base.plans.detail.plan.feature.detail', {pslug:'taxplan', fslug:recommendation.action_type});
                        }
                        break;
                    case 'download_app':
                    case 'notifications':
                    case 'partner_referral':
                    case 'none':
                    /* falls through */
                    default:
                        //already on recommendation page, all that's left is completing?
                        planData.backToPlanning = true;
                        break;
                }

            }).then(function() {
                if (recommendation.completable && plan.partnerListSurveyId.indexOf(recommendation.action_type) === -1) {
                    return plan.completeRecommendation(recommendation.recommendation_slug).then(function() {
                        if (recommendation.recommendation_slug) {
                            var r;
                            r = plan.getRecommendations(recommendation.recommendation_slug);
                            //might not exist if it's a link directly to landing page
                            if (r) {
                                r.justCompleted = true;
                            }
                        }
                    });
                }
            }).then(function() {
                // //Needs to be handled in controller since it could be going back to overview
                // if (backToPlanning) {
                //     $state.go('base.planning');
                // }
                return planData.backToPlanning;
            });

        };

        plan.formatSavedAnswers = function(questions, answers, skipped) {
            var formattedAnswers = [];

            angular.forEach(questions, function(q) {
                var formattedA, a, answerArray = null, otherId;
                if (q.id in answers) {

                    formattedA = {question_id: q.id, question_code: q.code};

                    a = answers[q.id];
                    if (a && typeof a === "object") {
                        answerArray = [];
                        angular.forEach(a, function(value, code) {
                            if (value) {
                                answerArray.push(code);
                            }
                        });
                        formattedA.answer_array = answerArray;
                    } else {
                        formattedA.answer = a;
                    }
                    formattedAnswers.push(formattedA);

                    otherId = q.id + "other";
                    if (otherId in answers) {
                        formattedAnswers.push({
                            question_id: otherId,
                            question_code: q.code + "[other]",
                            answer: answers[otherId],
                        });
                    }

                } else if (skipped.indexOf(q.id) > -1) {
                    formattedAnswers.push({
                        question_id: q.id,
                        question_code: q.code,
                        answer: '-skip-'
                    });
                }
            });

            return formattedAnswers;
        };

        plan.getReceiptInfo = function(prevInfo, prevRecommendations) {
            var newRecommendations, surveys;
            var data = {
                state: null,
                newCount: null
            };
            var info = plan.getRecommendationInfo();
            var recommendations = plan.getRecommendations();

            if (prevInfo && info && prevInfo.current_stage !== info.current_stage) {
                data.state = 'new-stage';
            } else {
                surveys = recommendations.filter(function(value) {
                    return value.action === "survey";
                });
                if (!surveys.length) {
                    data.state = "all-surveys-done";
                } else {

                    newRecommendations = recommendations.filter(function(r) {
                        return !prevRecommendations.find(function(pr) {
                            return pr.recommendation_slug === r.recommendation_slug;
                        });
                    });

                    data.newCount = newRecommendations.length;
                    if (data.newCount) {
                        data.state = "same-stage-new";
                    } else {
                        data.state = "same-stage-no-new";
                    }
                }

            }
            return data;
        };

        plan.stageModal = function($scope) {
            var newScope;

            if (planData.stageCompletedName) {
                if (plan.stageModal.modalInstance
                    && plan.stageModal.modalInstance.result
                    && plan.stageModal.modalInstance.result.$$state
                    && plan.stageModal.modalInstance.result.$$state.status === 0
                ) {
                    //modal is still open, promise never resolved
                    return plan.stageModal.modalInstance;
                }
                newScope = $scope.$new();
                newScope.PS = plan;
                plan.stageModal.modalInstance = $uibModal.open({
                    templateUrl: "app/themes/aurea/templates/modal.planning-stage.tpl.html",
                    scope: newScope,
                    size: 'full',
                    windowClass: 'planning-stage-modal fade-in-out'
                });

                plan.stageModal.modalInstance.result.then(function() {
                    plan.gotoNextSurveyRecommendation(newScope);
                }).catch(angular.noop).finally(function () {
                    plan.setStageCompletedDone();
                });

                return plan.stageModal.modalInstance;
            } else {
                return false;
            }
        };
        plan.setStageCompletedDone = function() {
            planData.stageCompletedName = false;
        };

        plan.getNextSurveyRecommendation = function() {
            var recommendation = null;
            angular.forEach(plan.getRecommendations(), function(r) {
                if (!recommendation && r.action === "survey") {
                    recommendation = r;
                }
            });
            return recommendation;
        };

        plan.gotoNextSurveyRecommendation = function($scope) {
            var recommendation = plan.getNextSurveyRecommendation();
            if (recommendation) {
                return $scope.$state.go("base.planning.recommendation", {slugOrId: recommendation.recommendation_slug});
            } else {
                return $scope.$state.go("base.planning");
            }
        };

        //round percentages to nearest 0.05 for defined slider values
        plan.round05 = function (originalValue, ceil) {
            var rounded,
                value = originalValue,
                factor = 0.05;

            //fix floating point issues
            value = Math.round(value*100) / (factor*100);

            if (ceil) {
                rounded = Math.ceil(value)*factor;
            } else {
                rounded = Math.floor(value)*factor;
            }

            rounded = Math.round(rounded * 100) / 100;
            return rounded;
        };

        return plan;
    }]);
})();
